import authservice from "@/services/authService";

class OAuth2Handler {
  constructor() {
    this.clientId = process.env.VUE_APP_CLIENT_ID;
    this.authorizeUrl = process.env.VUE_APP_AUTHORITY;
    this.tokenUrl = `${process.env.VUE_APP_URL_BACKEND}/oidc/token`;
    this.redirectUri = process.env.VUE_APP_REDIRECT_URI_AUTH;
    //this.state = process.env.$"{RandomString(16)}_{RandomString(10)}_{RandomString(8)}";
    this.accessToken = null;
  }

  // Funzione per costruire l'URL di autorizzazione
  getAuthorizationUrl() {
    const url = new URL(`${this.authorizeUrl}oidc/auth`);
    url.searchParams.append('client_id', this.clientId);
    url.searchParams.append('redirect_uri', this.redirectUri);
    url.searchParams.append('response_type', process.env.VUE_APP_RESPONSE_TYPE_AUTH);
    url.searchParams.append('scope', process.env.VUE_APP_SCOPE_AUTH);
    return url.href;
  }

  // Funzione per ottenere il token usando il codice di autorizzazione
  async fetchToken(queryParams) {
    try {
      if(!queryParams.code){
        throw "code non presente"
      }
      const response = await  authservice.riceviTokenSpid({
        code: queryParams.code,
        state: queryParams.state ?? '',
        client_id: this.clientId,
        grant_type: "authorization_code",
      });
      this.accessToken = response.data.access_token;
      return response.data;
    } catch (error) {
      console.error('Error fetching the token:', error);
      throw error;
    }
  }

  async encryptTokenFse(token, idToken) {
    try{
      if(!token){
        throw "access_token non presente"
      }
      if(!idToken){
        throw "id_token non presente"
      }
      const response = await authservice.encryptToken(token, idToken);
      return response.data
    } catch (error) {
      console.error('Error encripting the token:', error);
      throw error;
    }
  }

  // Funzione per il logout (invalidazione del token)
  async logout() {
    // In OAuth2, il logout spesso significa semplicemente scartare il token dal lato client.
    // Se il server supporta un endpoint di revoca, puoi revocare il token qui.
    this.accessToken = null;
  }
}

export default OAuth2Handler;
